import { Icon } from '@iconify/react';
import toast from 'react-hot-toast';
import { useDiscipleStore } from '../../../../../store/discipleStore';
import { useDeleteDisciple } from '../hooks/useDeleteDisciple';
import { useIsReadOnly } from '../../../../../store/reportStore';
import { formatBirthDate } from '../../../../../utils/common';
import styles from './DiscipleList.module.css';

export const DiscipleList = () => {
  const { disciples } = useDiscipleStore();
  const { deleteDisciple } = useDeleteDisciple();
  const isReadOnly = useIsReadOnly();

  /**
   * 제자 종류 정보 문자열 생성 (부서 + 종류명 + 설명)
   * @param disciple 제자 객체
   * @returns 제자 종류 정보 문자열
   */
  const makeDiscipleInfo = (disciple: (typeof disciples)[0]) => {
    const department = disciple.department ? `[${disciple.department}] ` : '';
    const typeInfo = `${disciple.typeName || disciple.typeId}${disciple.typeDescription ? `(${disciple.typeDescription})` : ''}`;
    return `${department}${typeInfo}`;
  };

  /**
   * 제자 전체 정보 문자열 생성
   * @param disciple 제자 객체
   * @returns 제자 정보 문자열
   */
  const makeDiscipleInfo2 = (disciple: (typeof disciples)[0]) => {
    const detail = makeDiscipleInfo(disciple);
    const gender = disciple.gender === 'M' ? '남' : '여';
    const birthdate = formatBirthDate(disciple.birthdate);

    return `${detail}: ${disciple.name} (${birthdate}, ${gender})`;
  };

  /**
   * 제자 삭제 핸들러
   * @param disciple 삭제할 제자: [0]은 타입 제한을 위해 추가
   */
  const handleDeleteDisciple = (disciple: (typeof disciples)[0]) => {
    const info = makeDiscipleInfo2(disciple);
    const confirmMessage = `${info}\n\n정말 삭제하시겠습니까?`;

    if (window.confirm(confirmMessage)) {
      deleteDisciple(disciple.id as number)
        .then(() => toast.success('성공적으로 삭제했습니다'))
        .catch(() => toast.error('제자 삭제 중 오류가 발생했습니다. 다시 시도해주세요.'));
    }
  };

  return (
    <div className={`col-xs-12 col-sm-12 col-md-12 styled-text-group ${styles.listContainer}`}>
      {disciples.map((disciple, idx) => (
        <div className="styled-icon" key={idx}>
          <span className="seeker">
            {makeDiscipleInfo(disciple)}: {disciple.name}
            <span className={styles.metaInfo}>
              ({formatBirthDate(disciple.birthdate)}, {disciple.gender === 'M' ? '남' : '여'})
            </span>
          </span>
          {!isReadOnly && (
            <Icon
              icon="bi:x-circle-fill"
              onClick={() => handleDeleteDisciple(disciple)} // 제자 삭제
              className={styles.deleteIcon}
              color="rgba(153, 153, 153, 0.6)"
            />
          )}
        </div>
      ))}
    </div>
  );
};
